import axios from 'axios'
import Vue from 'vue'
import { translateError } from '../mixins/componentActions'

// const testApi = "http://192.168.1.114:3000/api"
const testApi = process.env.VUE_APP_API_URL
const APIUrl = process.env.NODE_ENV !== "development" ? process.env.VUE_APP_API_URL : testApi

export default {
  isPublic({ state }, pageName) {
    if (pageName.toLowerCase() === 'home') return true
    const page = state.pageProperties.pages.find(page => page.pageName === pageName)
    return { exist: !!page, isPublic: page && Boolean(page.isPublic) };
  },
  handleError: ({ commit, dispatch, state }, err) => {
    const page = state.pageProperties;
    let e = undefined
    const errors = page.errors ? page.errors[Vue.prototype.locale] : []
    errors.forEach(pageError => {
      console.log(pageError, err)
      if (Array.isArray(err.message)) {
        if (pageError.error === err.message[0]) {
          e = pageError.message;
        }
      } else {
        if (pageError.error === err.message) {
          e = pageError.message
        }
      }
    })
    console.error(err)
    if (err.formErr || e) {
      if (e) {
        if (err.cause) e = e + '<br>' + err.cause;
        commit('setModalOptions', { type: 'error', isActive: true, message: e })
      } else if (err.message && !Array.isArray(err.message) && page.errors && page.errors[err.message]) {
        commit('setModalOptions', { type: 'error', isActive: true, message: page.errors[err.message] })
        return
      } else if (Array.isArray(err.message)) {
        err.message[0] = err.message[0] === 'Email address is already in use.' ? 'Die E-Mail-Adresse wird bereits verwendet.' : err.message[0]
        commit('setModalOptions', { type: 'error', isActive: true, message: translateError(err.message[0]) })
      } else if (err.message.includes('IDS_Sms_MessageController_E_INVALID_MSISDN')) {
        commit('setModalOptions', { type: 'error', isActive: true, message: 'Numarul de telefon introdus nu este valid' });
      } else if (err.message) {
        commit('setModalOptions', { type: 'error', isActive: true, message: translateError(err.message) })
      } else {
        commit('setModalOptions', { type: 'error', isActive: true, message: 'Conexiunea cu serverul nu a putut fi realizata. Asigura-te ca exista o conexiune stabila la internet si incearca din nou.' })
      }
    } else if (err.message) {
      if (err.cause) err.message = err.message + '<br>' + err.cause;
      commit('setModalOptions', { type: 'error', isActive: true, message: translateError(err.message) })
    } else {
      commit('setModalOptions', { type: 'error', isActive: true, message: 'Conexiunea cu serverul nu a putut fi realizata. Asigura-te ca exista o conexiune stabila la internet si incearca din nou.' })
    }
    if (!err) {
      commit('setModalOptions', { type: 'error', isActive: true, message: 'Conexiunea cu serverul nu a putut fi realizata. Asigura-te ca exista o conexiune stabila la internet si incearca din nou.' })
    }
  },

  setPageProperties: ({
    commit
  }, properties) => {
    commit('setPageProperties', properties);
  },

  refreshTempId: ({ commit, getters, dispatch }) => {
    return axios.post(`${APIUrl}/tempId`, { campaignId: getters.campaignId })
      .then(resp => {
        if (resp.data.response) {
          const data = {
            field: 'customerToken',
            value: resp.data.customerToken
          }
          commit('setField', data)
        } else if (resp.data.message) {
          dispatch('handleError', { message: resp.data.message, code: resp.data.code })
          commit('setField', { field: 'customerToken', value: '' })
          setTimeout(() => {
            location.href = '/'
          }, 10000)
        }
      })
      .catch(err => {
        dispatch('handleError', { message: 'Campaign not found', code: err.response.status })
        commit('setField', { field: 'customerToken', value: '' })
        setTimeout(() => {
          location.href = '/'
        }, 5000)
      })
  },

  setComponentStatus: ({ commit }, { component, status }) => {
    commit('setComponentStatus', { component, status });
  },

  retrieveUserToken({ commit, dispatch, state }) {
    // eslint-disable-next-line
    // if (window.dataLayer) {
    //     // eslint-disable-next-line
    //     dataLayer.push(
    //         {
    //             'event_action': 'PageView'
    //         }
    //     )
    // }
  },
  check72Hours ({ getters }, data) {
    const formData = {}
    formData.receiptToken = data
    formData.campaignId = getters.campaignId
    return new Promise((resolve, reject) => {
      axios.post(`${APIUrl}/check72Hours`, formData)
        .then(resp => {
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  isUpdateIban: ({ commit, getters }, data) => {
    return new Promise((resolve, reject) => {
      axios.get(APIUrl + `/ibanUpdateCheck/${data.customerToken}/${getters.campaignId}`)
        .then(resp => {
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  sendFormData({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      if (window.nsId) {
        data.formData.nsId = window.nsId;
      }

      const headers = {}
      if (data.recaptchaToken) { // reCAPTCHA v3
        headers['recaptcha-token'] = data.recaptchaToken
      } else if (window.grecaptcha) { // reCAPTCHA v2
        try {
          const token = window.grecaptcha.getResponse()
          if (token){
            headers['recaptcha-token'] = token
          }
        }
        catch (e) {
          console.log('');
        }
      }
      axios.post(APIUrl + data.endpoint, data.formData, { headers: headers })
        .then(res => {
          if (data.triggers && data.triggers.neuStarTrigger) {
            // console.log("3. will send::: neutrigger", data.triggers)
            let a = window._agknEchoTag;
            if (a && data.n) {
              a.setBpId('firstp');
              a.addEchoKeyValue('event', 'submit');
              a.generateTag();
            }
          }
          if (res.data.response) {
            return resolve(res.data)
          } else {
            if (res.data.invalid_fields) {
              //janrain error
              dispatch('handleError', { formErr: true, message: res.data.invalid_fields })
            } else if (res.data.message) {

              dispatch('handleError', { formErr: true, message: res.data.message })
            } else {
              dispatch('handleError', { formErr: true, code: res.data })
            }
            return reject(res.data)
          }
          // if (res.data.response) {
          //   commit('setReferenceNumber', res.data.referenceNumber)
          //   return { success: true }
          // } else {
          //   dispatch('handleError', res.data.error)
          //   return { success: false, error: res.data.error }
          // }
        })
        .catch(ex => {
          dispatch('handleError', {
            message: `Conexiunea cu serverul nu a putut fi realizata. Asigura-te ca exista o conexiune stabila la internet si incearca din nou.`
          })
          return { success: false, error: ex.message }
        })
    })
  },

  uploadProductPhotos({ getters, commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      // console.log("DATRA", data)
      const formData = new FormData()
      formData.append('productPhoto', data.image, 'productPhoto.png')
      formData.append('customerToken', getters.customerToken)
      formData.append('campaignId', getters.campaignId)
      formData.append('receiptToken', data.receiptToken)

      if (formData.customerToken == 1) {
        formData.append('token', data.token)
      }

      axios.post(APIUrl + data.endpoint, formData)
        .then(res => {

          return resolve(res.data)
          // if (res.data.response) {
          //   commit('setReferenceNumber', res.data.referenceNumber)
          //   return { success: true }
          // } else {
          //   dispatch('handleError', res.data.error)
          //   return { success: false, error: res.data.error }
          // }
        })
        .catch(ex => {
          dispatch('handleError', {
            message: `Conexiunea cu serverul nu a putut fi realizata. Asigura-te ca exista o conexiune stabila la internet si incearca din nou.`
          })
          return { success: false, error: ex.message }
        })
    })
  },

  generateCode({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      data.formData.customerToken = state.customerToken
      data.formData.campaignId = state.campaignId
      data.formData.receiptToken = state.receiptToken
      axios.post(APIUrl + data.endpoint, data.formData)
        .then(res => {
          if (res.data.response) {
            return resolve(res.data)
          } else {
            dispatch('handleError', { formErr: true, message: res.data.message })
            return reject(res.data)
          }
          // if (res.data.response) {
          //   commit('setReferenceNumber', res.data.referenceNumber)
          //   return { success: true }
          // } else {
          //   dispatch('handleError', res.data.error)
          //   return { success: false, error: res.data.error }
          // }
        })
        .catch(ex => {
          dispatch('handleError', {
            message: `Conexiunea cu serverul nu a putut fi realizata. Asigura-te ca exista o conexiune stabila la internet si incearca din nou.`
          })
          return { success: false, error: ex.message }
        })
    })
  },

  verifyCode({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      data.formData.customerToken = state.customerToken
      data.formData.campaignId = state.campaignId
      data.formData.receiptToken = state.receiptToken

      axios.post(APIUrl + data.endpoint, data.formData)
        .then(res => {
          // console.log(res.data)
          return resolve(res.data)
          // if (res.data.response) {
          //   commit('setReferenceNumber', res.data.referenceNumber)
          //   return { success: true }
          // } else {
          //   dispatch('handleError', res.data.error)
          //   return { success: false, error: res.data.error }
          // }
        })
        .catch(ex => {
          dispatch('handleError', {
            message: `Conexiunea cu serverul nu a putut fi realizata. Asigura-te ca exista o conexiune stabila la internet si incearca din nou.`
          })
          return { success: false, error: ex.message }
        })
    })
  },

  sendProducts({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      data.formData.customerToken = state.customerToken
      data.formData.campaignId = state.campaignId
      axios.post(APIUrl + data.endpoint, data.formData)
        .then(res => {
          if (res.data.response) return resolve(res.data)
          else dispatch('handleError', { message: res.data.message })
          // if (res.data.response) {
          //   commit('setReferenceNumber', res.data.referenceNumber)
          //   return { success: true }
          // } else {
          //   dispatch('handleError', res.data.error)
          //   return { success: false, error: res.data.error }
          // }
        })
        .catch(ex => {
          dispatch('handleError', {
            message: `Conexiunea cu serverul nu a putut fi realizata. Asigura-te ca exista o conexiune stabila la internet si incearca din nou.`
          })
          return { success: false, error: ex.message }
        })
    })
  },

  uploadReceipt({ getters, commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      if (data.receiptToken) {
        formData.append('receiptToken', data.receiptToken)

      }
      if (APIUrl.includes('localhost') || APIUrl.includes('192.168.1')) {
        formData.append('imageUrl', 'https://jolt-assets.s3.eu-central-1.amazonaws.com/template/0814c81a-0d8a-4f70-ae00-be7752de6846.png')
        data.apiUrl = 'http://192.168.1.114:3001/api/createReceipt'
        formData.append('campaignId', data.subCampaignId)
      } else {
        formData.append('receipt', data.image, 'receipt.png')
        formData.append('campaignId', data.campaignId)
      }
      formData.append('userToken', data.customerToken)
      formData.append('subCampaignId', getters.campaignId)

      if (data.token) {
        formData.append('token', data.token)
      }

      return axios.post(`${data.apiUrl}`, formData)
        .then(resp => {
          if (resp.data.response !== 'ERR') {
            // commit('setReceiptUploaded', true)
            // commit('setReceipt', image)

            // if (resp.data.data && resp.data.processor !== 'manual') {
            // console.log(resp.data.receiptToken)
            commit('setReceiptToken', resp.data.receiptToken)
            // }

            return resolve(resp.data.receiptToken);
          } else {
            dispatch('handleError', resp.data.error)
          }
        })
        .catch(resp => {
          let errorCode = '';
          if (resp.response && resp.response.data) {
            errorCode = resp.response.data.error;
          }
          dispatch('handleError', {
            message: `Conexiunea cu serverul nu a putut fi realizata. Asigura-te ca exista o conexiune stabila la internet si incearca din nou.`
          });

          return reject();
        });
    })
  },

  onReceiptUploadSuccess({ commit }, data) {
    commit('setReceiptImage', data)
  }
}

export function updateFavicon(url) {
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = url;
  document.getElementsByTagName("head")[0].appendChild(link);
}